export const correlatedLogger = (logger, correlation) => ({
    debug: (message, context) => logger.debug(message, { ...correlation(), ...context }),
    info: (message, context) => logger.info(message, { ...correlation(), ...context }),
    warn: (message, context) => logger.warn(message, { ...correlation(), ...context }),
    error: (message, context) => logger.error(message, { ...correlation(), ...context }),
});
